import { render } from "./NewsSwiper.vue?vue&type=template&id=67ff31af"
import script from "./NewsSwiper.vue?vue&type=script&lang=js"
export * from "./NewsSwiper.vue?vue&type=script&lang=js"

import "./NewsSwiper.vue?vue&type=style&index=0&id=67ff31af&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__